import AxiosInstance from "./api";

export const AllocationSheetScheduleService = {
  getPaginate: async (query) => {
    return await AxiosInstance.get("/private/allocation-sheet-schedule", { params: query });
  },
  getById: async (id) => {
    return await AxiosInstance.get(`/private/allocation-sheet-schedule/${id}`);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/allocation-sheet-schedule", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch(`/private/allocation-sheet-schedule/${id}`, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete(`/private/allocation-sheet-schedule/${id}`);
  },
};
